/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerRemoveMutationResponse, RolesControllerRemovePathParams, RolesControllerRemoveQueryParams, RolesControllerRemove400, RolesControllerRemove401, RolesControllerRemove403, RolesControllerRemove404, RolesControllerRemove409 } from "../../models/rolesController/RolesControllerRemove";

function getRolesControllerRemoveUrl(id: RolesControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/roles/${id}` as const }  
  return res
}

/**
 * @summary Delete a custom role (soft delete), optionally reassigning its holders to another role
 * {@link /api/v1/roles/:id}
 */
export async function rolesControllerRemove(id: RolesControllerRemovePathParams["id"], params?: RolesControllerRemoveQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RolesControllerRemoveMutationResponse, ResponseErrorConfig<RolesControllerRemove400 | RolesControllerRemove401 | RolesControllerRemove403 | RolesControllerRemove404 | RolesControllerRemove409>, unknown>({ method : "DELETE", url : getRolesControllerRemoveUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}